import classnames from "classnames";
import React, { HTMLProps } from "react";

import { IconName, icons } from "./icons";

import "./icon.css";

const getIconExtraClass = (iconName: string) => {
	switch (iconName) {
		case "dots-vertical":
			return "icon--rotate-90";
		default:
			return undefined;
	}
};

export const Icon = ({
	iconName,
	children,
	...props
}: {
	iconName?: string;
} & HTMLProps<HTMLSpanElement>) => {
	if (children) {
		const classname = classnames(
			props.className,
			"icon",
			"icon--icon-component",
			`icon--${iconName}`,
			getIconExtraClass(iconName ?? ""),
		);

		return (
			<span {...props} className={classname}>
				{children}
			</span>
		);
	}

	if (iconName) {
		const classname = classnames(
			props.className,
			"icon",
			"icon--icon-name",
			`icon--${iconName}`,
			getIconExtraClass(iconName),
		);

		return (
			<span
				{...props}
				className={classname}
				dangerouslySetInnerHTML={{ __html: icons[iconName as IconName] }}
			/>
		);
	}

	// iconName or children needed, throw?
	return null;
};

Icon.displayName = "Icon";
